// firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBubl78S7Czvh82enfzxaXskBRhEKAd2cs",
  authDomain: "hotel-rating-app-b6407.firebaseapp.com",
  projectId: "hotel-rating-app-b6407",
  storageBucket: "hotel-rating-app-b6407.firebasestorage.app",
  messagingSenderId: "772482920158",
  appId: "1:772482920158:web:50116916be665d32225c4f"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const analytics = getAnalytics(app);

export { db, auth, analytics };
